export const getBaseUrl = (env) => {
  switch (env) {
    case "dev":
    case "it":
      return "https://insightwallapi-it.us.bank-dns.com/v1";
    case "uat":
      return "https://uat-insights.elavon.com/v1";
    case "prod":
      return "https://insights.elavon.com/v1";
    default:
      return "https://insights.elavon.com/v1";
  }
};
